import { useQuery } from "@tanstack/react-query";
import apiTokenRepository from "@/repository/apiTokenRepository";
import { apiQueryKeys } from "./keys";


const getData = async () => {
    const { data } = await apiTokenRepository.read();
    return data?.token ?? "";
};

export const useAPIToken = () => {
    return useQuery<string>({
        queryKey: apiQueryKeys.read(),
        queryFn: () => getData()
    });
};
